import React, {useState, useContext} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewSeller from './new';
import EditSeller from './edit';
import NewContact from '../Contacts/new';
import NewAsset from '../Assets/new';
import AssignmentNotifications from 'app/src/components/Notifications/Assignments';
import { SubNavContainer } from 'app/src/elements';
import { HIDE_SELLER } from './queries';

import ResourceNotifications from 'app/src/components/Notifications/Resource';
import AuthContext from '../../contexts/AuthContext';

// const NavbarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;

//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = props => {
  const {
    seller,
    refetch,
    assignmentNotifications,
    setUpdatedContactDetails,
  } = props;

  const { hasPolicy } = useContext(AuthContext);
  const [showAddSellerModal, setShowAddSellerModal] = useState(false);
  const [showEditSellerModal, setShowEditSellerModal] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [showAddAssetModal, setShowAddAssetModal] = useState(false);
  const [showAssignmentsModal, setShowAssignmentsModal] = useState(false);
  const location = useLocation();
  const [hideSeller] = useMutation(
    HIDE_SELLER, { onCompleted: () => window.location.replace('/sellers') }
  )

  const onHide = (seller) => {
    if(window.confirm(`Hide ${seller.displayName}?`)) {
      hideSeller({ variables: { id: seller.id }});
    }
  };
  return (
    <SubNavContainer>
      {getLinks()}
    </SubNavContainer>
  )

  function getLinks() {
    const INDEX_PATHS = ['/sellers', '/sellers/pending', '/sellers/declined'];

    if(INDEX_PATHS.includes(location.pathname)) {
      return (
        <LinkContainer>
          {hasPolicy({ type: 'Fee', action: 'create' }) && (
            <>
              <Pressable
                onPress={() => setShowAddSellerModal(true)}
              >
                <Text>+ Add Seller</Text>
              </Pressable>
              <LinkSpace />
            </>
          )}
          <Link to="/title-logs">
            <Text>Titles</Text>
          </Link>
          <LinkSpace />
          <Link to="/sellers/pending">
            <Text>Pending Review</Text>
          </Link>
          <LinkSpace />
          <Link to="/sellers/declined">
            <Text>Declined Sellers</Text>
          </Link>
          {showAddSellerModal &&
            <Modal
              showModal={showAddSellerModal}
              setShowModal={setShowAddSellerModal}
              modalType={'Add Seller'}
              sellerId={seller?.id}
            >
              <NewSeller
                setShowModal={setShowAddSellerModal}
                refetch={refetch}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }else if(location.pathname === '/sellers/new') {
      return (
        <Link to={`/sellers`}>
          <Text>Sellers</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <BoldLinkText>{seller.displayName}</BoldLinkText>
          <LinkSpace />
          {hasPolicy({ type: 'Fee', action: 'create' }) && (
            <>
              <Pressable
                onPress={() => {
                  setShowEditSellerModal(true)
                }}
              >
                <Text>Edit</Text>
              </Pressable>
              <LinkSpace/>
            </>
          )}
          {hasPolicy({ type: 'Seller', action: 'hide' }) && (
            <Pressable
              onPress={() => onHide(seller)}
            >
              <Text>Hide</Text>
            </Pressable>
          )}
          {showEditSellerModal &&
            <Modal
              refetch={refetch}
              showModal={showEditSellerModal}
              setShowModal={setShowEditSellerModal}
              modalType={'Edit Seller'}
              objectName={seller.displayName}
            >
              <EditSeller
                setShowModal={setShowEditSellerModal}
                refetch={refetch}
                sellerDetails={seller}
              />
            </Modal>
          }
          <LinkSpace />
          {/* <Link to={`/sellers/${seller.id}/assets/new/${seller.name}`}>
            <Text>+ Add Asset</Text>
          </Link> */}
          <Pressable
            onPress={() => setShowAddAssetModal(true)}
          >
            <Text>+ Add Asset</Text>
          </Pressable>
          <LinkSpace />
          <Pressable
            onPress={() => setShowAddContactModal(true)}
          >
            <Text>+ Add Contact</Text>
          </Pressable>
          <LinkSpace />
          <View>
            <ResourceNotifications
              resource={{...seller, __typename: 'Seller'}}
              labeled
            />
          </View>
          <LinkSpace />
          {assignmentNotifications && (
            <View>
              <Pressable onPress={() => setShowAssignmentsModal(true)}>
                <Text>
                  Assignment By Seller ({assignmentNotifications?.length})
                </Text>
              </Pressable>
            </View>
          )}
          {showAddContactModal &&
            <Modal
              showModal={showAddContactModal}
              setShowModal={setShowAddContactModal}
              modalType={'Add Contact'}
            >
              <NewContact
                setShowModal={setShowAddContactModal}
                refetch={refetch}
                sellerId={seller.id}
                setUpdatedContactDetails={setUpdatedContactDetails}
              />
            </Modal>
          }
          {showAddAssetModal &&
            <Modal
              showModal={showAddAssetModal}
              setShowModal={setShowAddAssetModal}
              modalType="Add Asset"
            >
              <NewAsset
                setShowModal={setShowAddAssetModal}
                refetch={refetch}
                sellerId={seller.id}
                withNav={false}
                sellerIsEquiplinc={seller.isEquiplinc}
                // setUpdatedContactDetails={setUpdatedAssetDetails}
              />
            </Modal>
          }
          {showAssignmentsModal &&
            <Modal
              showModal={showAssignmentsModal}
              setShowModal={setShowAssignmentsModal}
              modalType="Assignments By Seller"
            >
              <AssignmentNotifications
                setShowModal={setShowAssignmentsModal}
                refetch={refetch}
                data={{notifications: assignmentNotifications}}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
